import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store/index'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/details/:id',
    name: 'details',
    component: () => import(/* webpackChunkName: "details" */ '../views/Details.vue')
  },
  
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/auth/Login.vue')
  },
  {
    path: '/forget',
    name: 'forget',
    component: () => import(/* webpackChunkName: "forget" */ '../views/auth/Forget.vue')
  },
  {
    path: '/reset',
    name: 'reset',
    component: () => import(/* webpackChunkName: "reset" */ '../views/auth/Reset.vue')
  },
  {
    path: '/settings',
    name: 'settings',
   
    component: () => import(/* webpackChunkName: "settings" */ '../views/auth/Settings.vue'),
    beforeEnter: requireAuth,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/search',
    name: 'search',
    component: () => import(/* webpackChunkName: "search" */ '../views/Search.vue')
  },
  {
    path: '/categories',
    name: 'categories',
    component: () => import(/* webpackChunkName: "Categories" */ '../views/Categories.vue')
  },
  {
    path: '/category/:link',
    name: 'category',
    component: () => import(/* webpackChunkName: "Category" */ '../views/Category.vue')
  },
  {
    path: '/upload',
    name: 'upload',
    beforeEnter: requireAuth,
    component: () => import(/* webpackChunkName: "upload" */ '../views/Upload.vue'),
    meta: {
      requiresAuth: true,
  }
  },
  {
    path: '/profile/:id',
    name: 'profile',
    component: () => import(/* webpackChunkName: "profile" */ '../views/auth/Profile.vue')
  },
  {
    path: '/photographers',
    name: 'photographers',
    component: () => import(/* webpackChunkName: "photographers" */ '../views/Photographers.vue')
  },
]

const router = new VueRouter({
  mode:'history',
  routes,
 
})
function requireAuth (to, from, next) {
  if(to.matched.some(record => record.meta.requiresAuth)) {
  if (store.getters['auth/isLoggedIn']) {
    next()
    return
  }
  router.push("/login", () => {});
} else {
  next()
}
}
export default router
